import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { api } from "../lib/api";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileBottomBar from "../components/MobileBottomBar";
import EmailPopup from "../components/EmailPopup";

export default function PublicLayout() {
  const { pathname, search } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

  // capture affiliate ref code
  React.useEffect(() => {
    const params = new URLSearchParams(search);
    const ref = params.get("ref");
    if (ref) {
      api.get(`/affiliate/${ref}`).then(({ data }) => {
        localStorage.setItem("pa_affiliate", JSON.stringify(data));
      }).catch(() => {});
    }
  }, []); // eslint-disable-line

  // track pageview
  React.useEffect(() => {
    api.post("/track", { path: pathname, ref: localStorage.getItem("pa_affiliate") ? "affiliate" : "" }).catch(() => {});
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-ivory">
      <Header />
      <main className="flex-1 pb-16 md:pb-0">
        <Outlet />
      </main>
      <Footer />
      <MobileBottomBar />
      <EmailPopup />
    </div>
  );
}
